module.exports = __webpack_public_path__ + "img/fj.d1ed662e.svg";